import clsx from "clsx";
import type { ReactNode } from "react";

import { Checkbox } from "./checkbox";

/**
 * チェックボックス＋ラベル（テキスト or アイコン）の選択行。area / condition フィルター共通。
 * sr-only の実 input でフォーカス可能性を担保し、Checkbox が視覚表現を担う。
 */
export function CheckItem({
  checked,
  onChange,
  className,
  ariaLabel,
  children,
}: {
  checked: boolean;
  onChange: () => void;
  className?: string;
  ariaLabel?: string;
  children: ReactNode;
}) {
  return (
    <label
      aria-label={ariaLabel}
      className={clsx("group flex cursor-pointer items-center", className)}
    >
      <input
        type="checkbox"
        className="sr-only"
        checked={checked}
        onChange={onChange}
      />
      <Checkbox checked={checked} />
      {children}
    </label>
  );
}
